export class AzureRestorePointSpec {
    'restorePointId';
    'region';
    'vaultName';
    'vaultResourceGroup';
    'vaultType';
    'recoveryPointTime';
    'diskIds';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restorePointId",
            "baseName": "restorePointId",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultName",
            "baseName": "vaultName",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultResourceGroup",
            "baseName": "vaultResourceGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultType",
            "baseName": "vaultType",
            "type": "AzureVaultType",
            "format": ""
        },
        {
            "name": "recoveryPointTime",
            "baseName": "recoveryPointTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "diskIds",
            "baseName": "diskIds",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureRestorePointSpec.attributeTypeMap;
    }
    constructor() {
    }
}
